import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { WelcomeComponent } from './welcome/welcome.component';
import { AuthService } from './auth.service';
import { CookieService } from 'ngx-cookie-service';
import { AppCommonService } from './appcommon.service';
import { WelcomeGuard } from './welcome/welcome-guard.service';
import { PageNotFoundComponent } from './pagenotfound/page-not-found.component';
import { AuthGuard } from './auth-guard.service';
import { GlobalService } from './global.service';
import { HeaderAndNavigationService } from './headerandnavigation/headerandnavigation.service';
import { AccountGuard } from './account-guard.service';
import { LoginPageComponent } from './headerandnavigation/login/loginpage.component';
import { LogoutComponent } from './Logout.component';
import { ResetPasswordComponent } from './headerandnavigation/resetpassword/resetpassword.component';
import { LoginGuard } from './headerandnavigation/login/login-guard.service';
import { LoaderService } from './LoaderService';
import { ImpersonateLoginComponent } from './headerandnavigation/login/impersonatelogin.component';
import { RegisterComponent } from './headerandnavigation/register/register.component';
import { RegisterConfirmationComponent } from './headerandnavigation/register/registerconfirmation.component';
import { LoginResolver } from './headerandnavigation/login/login.resolver';
import { UnauthorizedComponent } from './users/unauthorized.component';
import { ForbiddenComponent } from './users/forbidden.component';
import { NoAccessComponent } from './users/noaccess.component';
import { HoldingComponent } from './genericpages/holding.component';

@NgModule({
  imports: [
        RouterModule.forRoot([
        
      //{ path: '', component: HoldingComponent,  canActivate: [WelcomeGuard] },
      { path: '', component: WelcomeComponent, canActivate: [WelcomeGuard] },
      { path: 'testarea', component: WelcomeComponent, canActivate: [WelcomeGuard] },
      //{ path: 'login', component: LoginPageComponent, canActivate: [LoginGuard] },
      { path: 'Login/Index', redirectTo: 'login' },
      { path: 'login/index', redirectTo: 'login' },
      { path: 'Login', redirectTo: 'login' },
      //{ path: 'login', component: LoginPageComponent, resolve: { LoginResolver }, redirectTo: '' },
      { path: 'login', component: LoginPageComponent, resolve: { LoginResolver }, redirectTo: '' },
      { path: 'impersonatelogin', component: ImpersonateLoginComponent, resolve: { LoginResolver } },
      { path: 'register', component: RegisterComponent, canActivate: [LoginGuard] },
      { path: 'registerconfirmation', component: RegisterConfirmationComponent, canActivate: [LoginGuard] },
      { path: 'noaccess', component: NoAccessComponent, pathMatch: 'full' },
      //{ path: 'holdingpage', component: HoldingComponent, pathMatch: 'full' },
      { path: 'resetpassword', component: ResetPasswordComponent },
      { path: 'logout', component: LogoutComponent },
      { path: 'unauthorized', component: UnauthorizedComponent },
      { path: 'forbidden', component: ForbiddenComponent },
      { path: '**', component: PageNotFoundComponent }
    ])
  ],
  exports: [
    RouterModule
  ],
  providers: [
    AuthService,
    WelcomeGuard,
    LoginGuard,
    AuthGuard,
    AccountGuard,
    AppCommonService,
    GlobalService,
    CookieService,
    HeaderAndNavigationService,
    LoaderService,
    LoginResolver
  ]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/app.routing.module.ts